module.exports = __webpack_public_path__ + "img/三菱自動車.e46ece71.png";